/** Utilitários de formatação compartilhados entre as telas do gabinete. */

/**
 * Converte um telefone digitado livremente para o formato E.164 exigido pela API.
 * Números brasileiros sem código de país (10 ou 11 dígitos) recebem o 55.
 * Retorna null quando o valor não forma um telefone válido.
 */
export function paraE164(entrada: string): string | null {
  const digitos = entrada.replace(/\D/g, '');
  if (!digitos) return null;
  const comPais = digitos.length <= 11 ? `55${digitos}` : digitos;
  return /^[1-9]\d{9,14}$/.test(comPais) ? `+${comPais}` : null;
}

/** Formata um E.164 para leitura: +55 85 98888-0000 */
export function formatarTelefone(e164?: string | null): string {
  if (!e164) return '—';
  const d = e164.replace(/\D/g, '');
  if (d.startsWith('55') && (d.length === 12 || d.length === 13)) {
    const ddd = d.slice(2, 4);
    const num = d.slice(4);
    const meio = num.length === 9 ? `${num.slice(0, 5)}-${num.slice(5)}` : `${num.slice(0, 4)}-${num.slice(4)}`;
    return `+55 ${ddd} ${meio}`;
  }
  return e164;
}

/** Data ISO (ou timestamp) para dd/mm/aaaa. */
export function formatarData(iso?: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleDateString('pt-BR');
}

/** Data ISO para dd/mm — usado em aniversários, onde o ano não importa. */
export function formatarDiaMes(iso?: string | null): string {
  if (!iso) return '—';
  // Datas 'date' do Postgres chegam como YYYY-MM-DD; fatiar evita o
  // deslocamento de fuso que new Date() aplicaria.
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (m) return `${m[3]}/${m[2]}`;
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? '—'
    : `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`;
}

/** Rótulo legível da base legal de contato (LGPD). */
export const ROTULO_BASE_LEGAL: Record<string, string> = {
  optin: 'Opt-in',
  optout: 'Opt-out',
  sem_base: 'Sem base',
};
